import React from 'react';
import { Form } from 'react-bootstrap';
import NumberFormat from 'react-number-format';

function BaseInput({
  value, onChange, readOnly, table, decimalScale, thousandSeparator, required, placeholder, disabled, isAllowed
}) {
  return (
    <NumberFormat
      disabled={disabled}
      value={value}
      thousandSeparator={thousandSeparator}
      decimalSeparator=","
      decimalScale={decimalScale}
      fixedDecimalScale
      displayType="input"
      onValueChange={(values) => onChange(values.floatValue)}
      className={table ? 'float-input-table' : ''}
      allowNegative={false}
      isAllowed={isAllowed}
      placeholder={placeholder}
      readOnly={readOnly}
      required={required}
      customInput={Form.Control}
    />
  );
}

export function MonetaryFloatInput(props) {
  return BaseInput({ ...props, decimalScale: 2, thousandSeparator: ' ' });
}

export function MonetaryFloatThousandsInput(props) {
  return BaseInput({ ...props, decimalScale: 3, thousandSeparator: ' ' });
}

export function FloatInput(props) {
  return BaseInput({ ...props, decimalScale: 2 });
}

export function FloatMarkInput(props){
  return BaseInput({ ...props, decimalScale: 2 });

}

export function FloatThousandsInput(props) {
  return BaseInput({ ...props, decimalScale: 3 });
}

export function IntegerInput(props) {
  return BaseInput({ ...props, decimalScale: 0 });
}

export function FloatFlexibleInput(props) {
  return BaseInput({ ...props });
}
